import { createAction } from '@reduxjs/toolkit';
import { VideoMergeCoreState, VideoMergeJob, VideoMergeSubmitPayload } from './model';

export const editorOpened = createAction<{
  initialNodes: VideoMergeCoreState['editor']['initialNodes'];
}>('creativeHub/videoMerge/editorOpened');

export const editorClosed = createAction('creativeHub/videoMerge/editorClosed');

export const setNodeTreeIsOpen = createAction<{ isOpen: VideoMergeCoreState['nodeTreeIsOpen'] }>(
  'creativeHub/videoMerge/setNodeTreeIsOpen',
);

export const mergeSubmitted = createAction<VideoMergeSubmitPayload>(
  'creativeHub/videoMerge/mergeSubmitted',
);

export const taskCreationStarted = createAction('creativeHub/videoMerge/taskCreationStarted');

export const taskCreationFailed = createAction<{ errorMessage: string }>(
  'creativeHub/videoMerge/taskCreationFailed',
);

export const taskCreated = createAction<{
  taskId: VideoMergeJob['taskId'];
  name: VideoMergeJob['name'];
  videoCount: VideoMergeJob['videoCount'];
  createdAt: VideoMergeJob['createdAt'];
}>('creativeHub/videoMerge/taskCreated');

export const taskSucceeded = createAction<{
  taskId: VideoMergeJob['taskId'];
  taskResult: VideoMergeJob['result'];
}>('creativeHub/videoMerge/taskSucceeded');

export const taskChanged = createAction<{
  taskId: VideoMergeJob['taskId'];
  stage: VideoMergeJob['stage'];
}>('creativeHub/videoMerge/taskChanged');

export const taskFailed = createAction<{
  taskId: VideoMergeJob['taskId'];
  errorMessage: string;
}>('creativeHub/videoMerge/taskFailed');

export const jobViewerClosed = createAction('creativeHub/videoMerge/jobViewerClosed');
